// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-discover-js": function componentSrcPagesDiscoverJs() {
    return import("./../../src/pages/discover.js"
    /* webpackChunkName: "component---src-pages-discover-js" */
    );
  },
  "component---src-pages-epg-player-js": function componentSrcPagesEpgPlayerJs() {
    return import("./../../src/pages/epg-player.js"
    /* webpackChunkName: "component---src-pages-epg-player-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-news-js": function componentSrcPagesNewsJs() {
    return import("./../../src/pages/news.js"
    /* webpackChunkName: "component---src-pages-news-js" */
    );
  },
  "component---src-pages-player-js": function componentSrcPagesPlayerJs() {
    return import("./../../src/pages/player.js"
    /* webpackChunkName: "component---src-pages-player-js" */
    );
  },
  "component---src-pages-search-js": function componentSrcPagesSearchJs() {
    return import("./../../src/pages/search.js"
    /* webpackChunkName: "component---src-pages-search-js" */
    );
  },
  "component---src-pages-watch-c-js": function componentSrcPagesWatchCJs() {
    return import("./../../src/pages/watch/c.js"
    /* webpackChunkName: "component---src-pages-watch-c-js" */
    );
  },
  "component---src-pages-watch-i-js": function componentSrcPagesWatchIJs() {
    return import("./../../src/pages/watch/i.js"
    /* webpackChunkName: "component---src-pages-watch-i-js" */
    );
  },
  "component---src-pages-watch-s-js": function componentSrcPagesWatchSJs() {
    return import("./../../src/pages/watch/s.js"
    /* webpackChunkName: "component---src-pages-watch-s-js" */
    );
  },
  "component---src-templates-static-page-template-js": function componentSrcTemplatesStaticPageTemplateJs() {
    return import("./../../src/templates/static-page-template.js"
    /* webpackChunkName: "component---src-templates-static-page-template-js" */
    );
  }
};